angular.module("showcaseApp")
    .controller("ModalNegotiationFilterContentController", ModalNegotiationFilterContentController);

/** @ngInject */
function ModalNegotiationFilterContentController(
    $translate,
    $localStorage,
    toastr,
    moment,
    paginationConstants
) {

    var vm = this;
    const DATE_FORMAT = $translate.instant("momentDateFormat");

    vm.$onInit = init;

    function init() {
        if (vm.options) {
            vm.originalFilters = angular.copy(vm.filters);
            vm.listFilter = vm.list;
            vm.sortOptions = paginationConstants.sortOptions[$translate.use().toLowerCase()];
            if (vm.options.dynamicFilterOptions) {
                if (vm.options.dynamicFilterOptions.sellers) {
                    vm.dynamicFilterOptions = {
                        sellers: vm.options.dynamicFilterOptions.sellers || getDynamicFilterOptionsModel(),
                        customers: vm.options.dynamicFilterOptions.customers || getDynamicFilterOptionsModel(),
                        tags: vm.options.dynamicFilterOptions.tags || getDynamicFilterOptionsModel()
                    };
                }
            }
        }
        assignFilterOptionMethods();
    }

    vm.closeModal = function (response, applyFilters) {
        if (!applyFilters) {
            vm.filters = vm.originalFilters;
        }
        if (response) {
            angular.copy(response, vm.response);
        } else {
            var cleanResponse = {
                filtered: vm.filters,
                selectedFilters: angular.copy(vm.filters),
                listFilter: vm.listFilter,
                sortSelected: vm.selectedSort,
                numPerPage: vm.numPerPage,
            };

            angular.copy(cleanResponse, vm.response);
        }
    };

    function getDefaultFilters() {
        return {
            title: "",
            sellerSelection: [],
            customerSelection: []
        };
    }

    function getDefaultNegotiationFilter() {
        return {
            sellerKeys: [],
            sellerSelection: { all: false, only: [], except: [] },
            customerSelection: { all: false, only: [], except: [] }
        };
    }

    vm.clearFilters = function () {
        vm.list.customerSelection = { all: false, only: [], except: [] };
        vm.list.sellerSelection = { all: false, only: [], except: [] };
        vm.filters = getDefaultFilters();
        vm.list = getDefaultNegotiationFilter();
        vm.listFilter = getDefaultNegotiationFilter();
    };

    vm.applyFilters = function () {
        var filters = angular.copy(vm.filters);

        if (filters.sinceDate || filters.sinceDate !== "") {
            vm.listFilter.sinceDate = moment(
                filters.sinceDate,
                DATE_FORMAT
            ).toDate();
        } else {
            delete vm.listFilter.sinceDate;
            vm.listFilter.sinceDate = null;
        }

        if (filters.untilDate || filters.untilDate !== "") {
            vm.listFilter.untilDate = moment(
                filters.untilDate,
                DATE_FORMAT
            ).toDate();
        } else {
            delete vm.listFilter.untilDate;
            vm.listFilter.untilDate = null;
        }

        vm.closeModal(
            {
                filtered: filters,
                selectedFilters: angular.copy(vm.filters),
                listFilter: vm.listFilter,
                sortSelected: vm.selectedSort,
                numPerPage: vm.numPerPage,
            },
            true
        );
    };

    vm.getTranslateKey = function (key) {
        return getTranslateKey(vm.isImmoContext, key);
    }

    function assignFilterOptionMethods() {
        if (!vm.options) return;

        const mapping = {
            listSellerFilterOptions: 'listSellerFilterOptions',
            listCustomersFilterOptions: 'listCustomersFilterOptions',
            listTagsFilterOptions: 'listTagsFilterOptions'

        };

        Object.keys(mapping).forEach(function (key) {
            if (vm.options[key] && angular.isFunction(vm.options[key])) {
                vm[mapping[key]] = findBindingBaseFunction(vm.options[key]);
            }
        });
    }

    function formatFilterOptions() {

        if (vm.filters.sinceDate) {
            vm.filters.sinceDate = moment(vm.filters.sinceDate, DATE_FORMAT).format(DATE_FORMAT);
        }

        if (vm.filters.untilDate) {
            vm.filters.untilDate = moment(vm.filters.untilDate, DATE_FORMAT).format(DATE_FORMAT);
        }
    }
}
